import { toRaw } from 'vue'

/**
 * Chave estável de um passo (evento/ação) do editor de automações.
 *
 * Os passos novos ainda não têm id (`eventStepId`/`workStepId` nulos), então a lista usava o ÍNDICE como `:key`: remover
 * um passo do meio fazia o Vue reaproveitar a instância do passo errado (o estado interno dos filhos — que carregam dados
 * no `beforeMount` — ficava trocado). A identidade do próprio objeto não muda com a posição: um WeakMap guarda um número
 * por objeto (sem escrever nada no passo, que vai inteiro no corpo do POST/PUT).
 */
const keys = new WeakMap()
let sequence = 0

export function stepKey (step) {
  const raw = toRaw(step)

  if (!raw || typeof raw !== 'object') return String(raw)

  if (!keys.has(raw)) {
    sequence += 1
    keys.set(raw, sequence)
  }

  return keys.get(raw)
}
